import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { HISTORY_ACTIONS } from "const";

export default function ScrollToTopOnMount() {
  const history = useHistory();
  const location = useLocation();

  // Re-run on every path change. Inside the router's <Switch> consecutive
  // public routes render this component at the same position, so React reuses
  // the instance instead of remounting it — depending on history.action alone
  // never fires between two PUSH navigations. location.pathname does change,
  // and the POP guard still preserves scroll position on back/forward.
  useEffect(() => {
    if (history.action !== HISTORY_ACTIONS.POP) window.scrollTo({ top: 0 });
  }, [history.action, location.pathname]);

  return null;
}
